import ReactGA from 'react-ga';

const TRACKING_ID = 'UA-XXXXXXXXX-X';

const init = () => {
    ReactGA.initialize(TRACKING_ID);
};

const sendEvent = (category: string, action: string, label?: string, value?: number) => {
    ReactGA.event({ category, action, label, value });
};

const sendFormEvent = (action: string, label: string) => {
    ReactGA.event({ category: 'FORM', action, label: `APP_${label}` });
};

const sendButtonEvent = (action: string, label: string) => {
    ReactGA.event({ category: 'BUTTON', action, label: `APP_${label}` });
};

const sendLinkEvent = (action: string, label: string) => {
    ReactGA.event({ category: 'LINK', action, label: `APP_${label}` });
};

const sendCTAEvent = (action: string, label: string) => {
    ReactGA.event({ category: 'CTA', action, label });
};

const sendPageview = (path: string) => {
    ReactGA.set({ page: path });
    ReactGA.pageview(path);
};

const analytics = {
    init,
    sendEvent,
    sendFormEvent,
    sendButtonEvent,
    sendLinkEvent,
    sendCTAEvent,
    sendPageview,
};

export default analytics;
